/**
 * Beitrittscodes fuer private Matches (Masterprompt Abschnitt 88).
 *
 * Der Code wird vorgelesen und abgetippt - deshalb fehlen im Alphabet alle
 * Zeichen, die man leicht verwechselt: 0 und O, 1 und I, 5 und S.
 */

/** Zeichen, aus denen ein Code besteht. */
export const MATCH_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRTUVWXYZ23479';

/** Laenge eines Codes. */
export const MATCH_CODE_LENGTH = 5;

/**
 * Erzeugt einen neuen Code.
 *
 * @param random Zufallsquelle, standardmaessig Math.random. In Tests wird sie
 *   ersetzt, damit das Ergebnis vorhersehbar ist.
 */
export function createMatchCode(random: () => number = Math.random): string {
  let code = '';
  for (let i = 0; i < MATCH_CODE_LENGTH; i += 1) {
    const index = Math.floor(random() * MATCH_CODE_ALPHABET.length) % MATCH_CODE_ALPHABET.length;
    code += MATCH_CODE_ALPHABET[index] ?? MATCH_CODE_ALPHABET[0];
  }
  return code;
}

/**
 * Bringt eine Eingabe in die Form, die der Server erwartet.
 *
 * Kleinbuchstaben, Leerzeichen und Bindestriche sind erlaubt - sie werden
 * stillschweigend entfernt. Wer "ab-cde" tippt, meint "ABCDE".
 */
export function normalizeMatchCode(input: string): string {
  return input
    .toUpperCase()
    .split('')
    .filter((zeichen) => MATCH_CODE_ALPHABET.includes(zeichen))
    .join('')
    .slice(0, MATCH_CODE_LENGTH);
}

/** Ist das ein vollstaendiger, gueltiger Code? */
export function isValidMatchCode(input: string): boolean {
  return normalizeMatchCode(input).length === MATCH_CODE_LENGTH;
}
